import React, {memo} from 'react';

import {useGetUserItemOffersQuery} from "store/Bazaar/bazaar.api";
import {useActiveItemContext} from "./useActiveItemContext";
import {INTERACTION, SIZE, STEPS_STATUS} from "utils";
import {useModalsContext} from "layouts";

import {ButtonV2} from "components/atoms";

import BazaarCurrentItemAccordionBlock from "./BazaarCurrentItemAccordionBlock";

const BazaarCurrentItemInteractionToolsMake = () => {
    const {data, chainId, handleAuthAndWalletChecks} = useActiveItemContext()
    const {setCurrentModal} = useModalsContext()

    const openModal = () => {
        if (!handleAuthAndWalletChecks()) return;

        const itemInfo = {
            chain: chainId,
            name: data.inventory.name,
            tokenId: data?.details.token_id,
        }

        setCurrentModal(prevState => ({...prevState, data: itemInfo, status: STEPS_STATUS.MAKE_OFFER}))
    }

    return (
        <div className="bazaar_current-item_interaction-tools_btn-group_tabs-content_make">
            <ButtonV2 onClick={openModal} size={SIZE.MEDIUM}>makeOffer</ButtonV2>
            <BazaarCurrentItemAccordionBlock
                totalOwnedNFT={0}
                interaction={INTERACTION.BUY}
                queryHook={useGetUserItemOffersQuery}
            />
        </div>
    )
}

export default memo(BazaarCurrentItemInteractionToolsMake);